import { render, staticRenderFns } from "./transaction-list-detail.html?vue&type=template&id=52b602b9&scoped=true&external"
import script from "./transaction-list-detail.js?vue&type=script&lang=js&external"
export * from "./transaction-list-detail.js?vue&type=script&lang=js&external"
import style0 from "./transaction-list-detail.scss?vue&type=style&index=0&id=52b602b9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b602b9",
  null
  
)

export default component.exports